// extracted by mini-css-extract-plugin
var _1 = "FcMam4ctQBnBdFVy708m";
export { _1 as "root" }
